export default "__VITE_ASSET__Cjln7q6w__"